/* eslint-disable @typescript-eslint/default-param-last */
import {
  ADD_PARTICIPANT,
  END_INTERVIEW_FOR_ALL,
  GET_ALL_PARTICIPANTS,
  LEAVE_INTERVIEW,
  PARTICIPANT_LEFT,
} from "../constants/ActionTypes";
import initialState from "../store/initialState";
import { IParticipantActionType } from "../types/participants.types";

const participantsReducer = (
  state = initialState.participants,
  action: IParticipantActionType,
) => {
  switch (action.type) {
    case `${GET_ALL_PARTICIPANTS}_SUCCESS`: {
      return { ...action.payload.participants };
    }
    case PARTICIPANT_LEFT: {
      const updatedParticipants = state;
      const { participantEmail } = action.payload;
      if (updatedParticipants[participantEmail]) {
        updatedParticipants[participantEmail].inInterview = false;
      }
      return { ...updatedParticipants };
    }
    case ADD_PARTICIPANT: {
      const updatedParticipants = state;
      const { participant } = action.payload;
      if (updatedParticipants[participant.email]) {
        updatedParticipants[participant.email] = participant;
      }
      return { ...updatedParticipants };
    }
    case `${LEAVE_INTERVIEW}_SUCCESS`:
    case `${END_INTERVIEW_FOR_ALL}_SUCCESS`:
      return initialState.participants;
    default:
      return state;
  }
};

export default participantsReducer;
